import { createTheme as createMuiTheme, Palette, Theme as MuiTheme } from '@mui/material';
import { Shadows as MuiShadows } from '@mui/material/styles/shadows';
import { theme } from '@myme/utils';
import { softShadows } from './shadows';
import { typography } from './typography';
import { webPalette } from './webPalette';

export interface CustomMuiTheme extends MuiTheme {
  name: string;
  palette: Palette;
}

interface ThemeOptions {
  name?: string;
  typography?: Record<string, Partial<unknown>>;
  overrides?: Record<string, unknown>;
  palette?: Record<string, unknown>;
  shadows?: MuiShadows;
}

const baseOptions: ThemeOptions = {
  typography
};

const themesOptions: ThemeOptions[] = [
  {
    name: 'default',
    palette: {
      type: 'light',
      action: {
        active: theme.colors.primary
      },
      background: {
        default: theme.colors.backgroundPrimary,
        paper: theme.colors.backgroundSecondary
      },
      divider: theme.colors.textPrimary,
      primary: {
        main: theme.colors.primary
      },
      secondary: {
        main: webPalette.layoutUserPopover
      },
      text: {
        primary: theme.colors.textPrimary,
        secondary: theme.colors.textSecondary
      },
      error: {
        main: theme.colors.error,
        light: webPalette.lightError
      },
      warning: {
        main: theme.colors.warning
      },
      success: {
        main: theme.colors.success
      }
    },
    shadows: softShadows
  }
];

export const createTheme = (themeName: string): CustomMuiTheme => {
  const themeOptions = themesOptions.find(singleTheme => singleTheme.name === themeName);

  if (!themeOptions) {
    console.warn(new Error(`The theme ${themeName} is not valid`));
  }

  const muiTheme = createMuiTheme({ ...baseOptions, ...themeOptions });

  return muiTheme as CustomMuiTheme;
};
